function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import Panels from './components/panels';
import { jsx as ___EmotionJSX } from "@emotion/core";
class AllhomesTabbedPanel extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "setActivePanel", index => {
      if (this.props.panels[index]) {
        this.setState({
          activePanelIndex: index
        });
        if (this.props.onTabClick) {
          this.props.onTabClick(this.props.panels[index].tab, index);
        }
      }
    });
    this.state = {
      activePanelIndex: this.props.activePanelIndex
    };
  }
  render() {
    return ___EmotionJSX(Panels, _extends({}, this.props, {
      setActivePanel: this.setActivePanel,
      activePanelIndex: this.state.activePanelIndex
    }));
  }
}
AllhomesTabbedPanel.propTypes = {
  panels: Panels.propTypes.panels,
  activePanelIndex: PropTypes.number,
  className: PropTypes.string,
  tabWrapper: PropTypes.element,
  tabColour: PropTypes.string,
  tabInactiveColour: PropTypes.string,
  tabBorderColour: PropTypes.string,
  tabJustification: PropTypes.oneOf(['left', 'auto']),
  tabAlignment: PropTypes.oneOf(['left', 'centre']),
  tabGap: PropTypes.oneOf(['default', 'big']),
  underline: PropTypes.bool,
  type: PropTypes.oneOf(['js', 'css']),
  onTabClick: PropTypes.func,
  hoverColour: PropTypes.string,
  tabCountColour: PropTypes.string,
  customTabs: PropTypes.arrayOf(PropTypes.node)
};
AllhomesTabbedPanel.defaultProps = {
  panels: [],
  activePanelIndex: 0,
  tabAlignment: 'left',
  tabJustification: 'auto',
  tabGap: 'normal',
  underline: false,
  tabWrapper: undefined,
  tabColour: undefined,
  tabBorderColour: undefined,
  tabInactiveColour: undefined,
  className: null,
  type: 'css',
  onTabClick: () => {},
  hoverColour: undefined,
  tabCountColour: undefined,
  customTabs: []
};
export default AllhomesTabbedPanel;